(function () {
  /* on phones the industry picker is one scrolling row: keep the chosen chip in view */
  var tiles = document.querySelector('.ix-tiles'), reduce = false;
  try { reduce = matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  if (tiles) tiles.addEventListener('click', function (e) {
    var b = e.target.closest('[role="tab"]');
    if (b && tiles.scrollWidth > tiles.clientWidth + 2) { try { b.scrollIntoView({ inline: 'center', block: 'nearest', behavior: reduce ? 'auto' : 'smooth' }); } catch (x) {} }
  });
})();
(function () {
  /* "Not on the list?" form: checks the industry and a work email, shows a success state. In the Shopify theme the exporter turns it into the native contact form. */
  var form = document.querySelector('[data-ix-form]');
  if (!form) return;
  var field = form.querySelector('#tell-industry'), err = form.querySelector('#tell-industry-e');
  var mail = form.querySelector('#tell-email'), merr = form.querySelector('#tell-email-e'), ok = form.querySelector('[data-ix-ok]');
  var okMail = function () { return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(mail.value.trim()); };
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var badI = !field.value.trim(), badM = !okMail();
    err.hidden = !badI; merr.hidden = !badM;
    field.toggleAttribute('aria-invalid', badI); mail.toggleAttribute('aria-invalid', badM);
    if (badI || badM) { ok.hidden = true; (badI ? field : mail).focus(); return; }
    ok.hidden = false;
  });
  field.addEventListener('input', function () { if (field.value.trim()) { err.hidden = true; field.removeAttribute('aria-invalid'); } });
  mail.addEventListener('input', function () { if (okMail()) { merr.hidden = true; mail.removeAttribute('aria-invalid'); } });
})();
